import React from 'react';

export const FenceGray = () => (
  <g
    id="g104"
    transform="matrix(21.809703,0,0,21.809703,-5.2290236,57.291296)"
    strokeWidth="0.04585115"
  >
    <path
      fill="#182b4a"
      strokeWidth="0.04585115"
      d="M 48.317,35.285 H 1.682 A 1.417,1.417 0 0 1 0.24,33.842 C 0.24,33.025 0.865,32.4 1.682,32.4 h 46.635 c 0.817,0 1.442,0.625 1.442,1.442 0,0.818 -0.673,1.443 -1.442,1.443 z m 0,-18.65 H 1.682 A 1.417,1.417 0 0 1 0.24,15.192 c 0,-0.817 0.625,-1.442 1.442,-1.442 h 46.635 c 0.817,0 1.442,0.625 1.442,1.442 0,0.818 -0.673,1.443 -1.442,1.443 z"
    />
    <path
      id="path78"
      fill="#eaeff7"
      strokeWidth="0.04585115"
      d="M 44.38,42.648 H 35.87 V 5.868 L 40.1,1.59 44.38,5.869 Z m -30.722,0 H 5.1 V 5.868 L 9.379,1.59 13.658,5.869 Z m 15.332,0 H 20.48 V 5.868 l 4.279,-4.278 4.23,4.279 z"
    />
    <path
      id="path92"
      fill="#182b4a"
      strokeWidth="0.04585115"
      d="M 37.305,41.192 V 6.442 l 2.841,-2.837 2.842,2.836 v 34.75 z m 8.557,1.452 V 5.865 c 0,-0.385 -0.144,-0.721 -0.432,-1.01 L 41.15,0.577 c -0.528,-0.53 -1.49,-0.53 -2.018,0 l -4.28,4.278 C 34.564,5.095 34.42,5.48 34.42,5.865 v 36.779 c 0,0.817 0.625,1.442 1.442,1.442 h 8.51 c 0.817,0 1.442,-0.625 1.49,-1.442 z M 6.535,41.192 V 6.442 l 2.841,-2.837 2.842,2.836 v 34.75 z m 8.557,1.452 V 5.865 c 0,-0.385 -0.144,-0.721 -0.432,-1.01 L 10.38,0.577 c -0.528,-0.53 -1.49,-0.53 -2.018,0 L 4.082,4.855 C 3.794,5.095 3.65,5.48 3.65,5.865 v 36.779 c 0,0.817 0.625,1.442 1.442,1.442 h 8.558 c 0.77,0 1.442,-0.625 1.442,-1.442 z m 6.833,-1.452 V 6.442 l 2.841,-2.837 2.842,2.836 v 34.75 z m 8.557,1.452 V 5.865 c 0,-0.385 -0.144,-0.721 -0.432,-1.01 L 25.77,0.577 c -0.528,-0.53 -1.49,-0.53 -2.018,0 l -4.28,4.278 C 19.184,5.095 19.04,5.48 19.04,5.865 v 36.779 c 0,0.817 0.625,1.442 1.442,1.442 h 8.51 c 0.817,0 1.442,-0.625 1.49,-1.442 z"
    />
  </g>
);
